import DashboardCount from "../../slices/dashboard/DashboardCount";

const dashboardReducer = {
    dashboardCount: DashboardCount,
};

export default dashboardReducer;